module.exports = __webpack_public_path__ + "static/media/mobile-logo.9827f2ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/mobile-logo.svg
// module id = 1490
// module chunks = 0